(function(){
  if(window.jwMoreColorsAssetLoaded) return;
  window.jwMoreColorsAssetLoaded = true;

  var open = false;
  var closing = false;
  var closeTimer;
  var syncTimer;
  var btnAnimTimer;

  function syncRoot(){
    document.documentElement.classList.toggle('jw-more-open', open);
    document.documentElement.classList.toggle('jw-more-closing', closing);
  }

  function getFieldset(){
    return document.querySelector('main[data-template="product"] variant-selects fieldset.jw-more-colors');
  }

  function getExtras(fs){
    if(!fs || !fs.querySelectorAll) return [];

    return Array.from(fs.querySelectorAll('.swatch-input__input')).slice(7).map(function(input){
      var label = null;

      if(input.id && window.CSS && CSS.escape){
        label = fs.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      }else if(input.id){
        label = Array.from(fs.querySelectorAll('label')).find(function(l){
          return l.htmlFor === input.id;
        });
      }

      return { input:input, label:label };
    }).filter(function(p){
      return p.label;
    });
  }

  function getBtn(fs){
    return fs && fs.querySelector ? fs.querySelector('.jw-more-btn[data-jw-more="1"]') : null;
  }

  function getBtnMove(fs){
    var btn = getBtn(fs);
    if(!btn) return null;

    return {
      btn:btn,
      rect:btn.getBoundingClientRect()
    };
  }

  function animateBtn(move){
    if(!move || !move.btn || !document.body.contains(move.btn)) return;

    var btn = move.btn;
    var next = btn.getBoundingClientRect();
    var x = move.rect.left - next.left;
    var y = move.rect.top - next.top;

    if(Math.abs(x) < 1 && Math.abs(y) < 1) return;

    clearTimeout(btnAnimTimer);

    btn.style.transition = 'none';
    btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    btn.style.willChange = 'transform';

    void btn.offsetWidth;

    requestAnimationFrame(function(){
      btn.style.transition = 'transform 1.7s cubic-bezier(.22,1,.36,1), background .9s ease, color .9s ease, border-color .9s ease';
      btn.style.transform = 'translate(0,0)';
    });

    btnAnimTimer = setTimeout(function(){
      btn.style.transition = '';
      btn.style.transform = '';
      btn.style.willChange = '';
    }, 1780);
  }

  function update(fs){
    syncRoot();

    if(!fs || !fs.querySelector) fs = getFieldset();
    if(!fs) return;

    var btn = getBtn(fs);
    if(!btn) return;

    var label = (open || closing) ? 'Less' : 'More';

    if(btn.textContent.trim() !== label){
      btn.textContent = label;
    }

    btn.setAttribute('aria-expanded', (open || closing) ? 'true' : 'false');
    fs.classList.toggle('jw-more-open', open);
    fs.classList.toggle('jw-more-closing', closing);
  }

  function openMore(fs){
    clearTimeout(closeTimer);

    var move = getBtnMove(fs);

    open = true;
    closing = false;
    syncRoot();

    fs.classList.remove('jw-more-closing');
    fs.classList.add('jw-more-open');

    getExtras(fs).forEach(function(p,i){
      p.label.classList.remove('jw-more-out');
      p.label.style.setProperty('--jw-d', (i * 110) + 'ms');
      void p.label.offsetWidth;
      p.label.classList.add('jw-more-in');
    });

    update(fs);
    animateBtn(move);
  }

  function closeMore(fs){
    clearTimeout(closeTimer);

    open = false;
    closing = true;
    syncRoot();

    fs.classList.remove('jw-more-open');
    fs.classList.add('jw-more-closing');

    var extras = getExtras(fs);

    extras.forEach(function(p,i){
      p.label.classList.remove('jw-more-in');
      p.label.style.setProperty('--jw-d', ((extras.length - 1 - i) * 110) + 'ms');
      void p.label.offsetWidth;
      p.label.classList.add('jw-more-out');
    });

    update(fs);

    closeTimer = setTimeout(function(){
      var move = getBtnMove(fs);

      closing = false;
      fs.classList.remove('jw-more-closing');

      getExtras(fs).forEach(function(p){
        p.label.classList.remove('jw-more-out');
        p.label.style.setProperty('--jw-d','0ms');
      });

      syncRoot();
      update(fs);
      animateBtn(move);
    }, 1400 + Math.max(0, extras.length - 1) * 110);
  }

  function scheduleUpdate(){
    clearTimeout(syncTimer);

    update();

    syncTimer = setTimeout(function(){
      update();
    }, 30);
  }

  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;

    var btn = e.target.closest('.jw-more-btn[data-jw-more="1"]');
    if(!btn) return;

    var fs = btn.closest('fieldset.jw-more-colors');
    if(!fs) return;

    e.preventDefault();
    e.stopPropagation();

    if(open){
      closeMore(fs);
    }else{
      openMore(fs);
    }
  }, true);

  document.addEventListener('change', function(e){
    if(!e.target || !e.target.closest) return;

    if(e.target.closest('variant-selects')){
      update();
      setTimeout(update, 30);
      setTimeout(update, 100);
      setTimeout(update, 220);
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function(){
    update();
  });

  setTimeout(update, 50);
  setTimeout(update, 200);
  setTimeout(update, 700);

  var watch = document.querySelector('main[data-template="product"] product-info') || document.querySelector('main[data-template="product"] variant-selects');

  if(watch){
    new MutationObserver(function(){
      scheduleUpdate();
    }).observe(watch,{
      childList:true,
      subtree:true
    });
  }
})();